<template>
  <main>
    <div class="relative w-full min-h-screen bg-cover bg-center bg-no-repeat" 
        :style="{backgroundImage: `url(${require('../assets/images/leader-journey.jpg')})`,}">
      <!-- Dark overlay -->
      <div class="absolute inset-0 bg-[#1a1f3a] bg-opacity-70"></div>
      
      <!-- Content -->
      <div class="relative z-10 max-w-7xl mx-auto px-4 py-20">
        <!-- Title -->
        <h1 class="text-center text-4xl md:text-5xl lg:text-6xl font-bold mb-16 md:mb-20">
          <span class="text-white">MY LEADERSHIP </span>
          <span class="text-blue">JOURNEY</span>
        </h1>

        <!-- Stats Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 items-center">
          
          <!-- Card 1 -->
          <div class="bg-white rounded-3xl p-8 text-center shadow-xl transform hover:scale-105 transition-transform duration-300">
            <div class="flex justify-center mb-4">
              <div>
                <img src="../assets/images/mentees.png" alt="" class="w-16 h-16">
              </div>
            </div>
            <h2 class="text-3xl md:text-4xl font-bold text-blue mb-3">100,000+</h2>
            <p class="text-base font-semibold text-black leading-tight">
              Trained Mentees
            </p>
          </div>

          <!-- Card 2 -->
          <div class="bg-white rounded-3xl p-8 text-center shadow-xl transform hover:scale-105 transition-transform duration-300">
            <div class="flex justify-center mb-4">
              <div>
                <img src="../assets/images/worldwide.png" alt="" class="w-16 h-16">
              </div>
            </div>
            <h2 class="text-3xl md:text-4xl font-bold text-blue mb-3">1,000,000+</h2>
            <p class="text-base font-semibold text-black leading-tight">
              Lives Impacted Locally
            </p>
          </div>

          <!-- Card 3 - Featured Red Card -->
          <div class="bg-blue rounded-3xl p-8 text-center shadow-2xl transform lg:scale-110 hover:scale-115 transition-transform duration-300 z-10">
            <div class="flex justify-center mb-4">
              <div>
                <img src="../assets/images/reputation.png" alt="" class="w-16 h-16 filter invert">
              </div>
            </div>
            <h2 class="text-3xl md:text-4xl font-bold text-white mb-3">15+</h2>
            <p class="text-base font-bold text-white leading-tight">
              States Established Brand<br>Presence
            </p>
          </div>

          <!-- Card 4 -->
          <div class="bg-white rounded-3xl p-8 text-center shadow-xl transform hover:scale-105 transition-transform duration-300">
            <div class="flex justify-center mb-4">
              <div>
                <img src="../assets/images/delivered.png" alt="" class="w-16 h-16">
              </div>
            </div>
            <h2 class="text-3xl md:text-4xl font-bold text-blue mb-3">1,000+</h2>
            <p class="text-base font-semibold text-black leading-tight">
              Speeches Delivered locally
            </p>
          </div>

        </div>
      </div>

      <!-- Scroll to top button (bottom right) -->
      <button 
        @click="scrollToTop"
        class="fixed bottom-8 right-8 bg-white text-blue w-14 h-14 rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center z-50">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 15l7-7 7 7"/>
        </svg>
      </button>
    </div>
  </main>
</template>

<script>
export default {
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
/* Additional custom styles if needed */
</style>